import { render, staticRenderFns } from "./Game--Stats.vue?vue&type=template&id=12653bef&scoped=true&"
import script from "./Game--Stats.vue?vue&type=script&lang=js&"
export * from "./Game--Stats.vue?vue&type=script&lang=js&"
import style0 from "./Game--Stats.vue?vue&type=style&index=0&id=12653bef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12653bef",
  null
  
)

export default component.exports